module.exports = __webpack_public_path__ + "img/invoice-sm.ca043dc7.svg";